/*document.getElementById("create_customer").addEventListener("submit", (rgs_sem_e) => {
  if(!rgs_sem_e.target.checkValidity()){
    return;
  };
  rgs_sem_e.preventDefault();
  document.querySelectorAll("#rgs_sendmail_test_main .rgs_sendmail_load_main")[0].setAttribute("data-rgssmt_load_disp","true");
  rgs_load(0);
});*/

document.getElementById("rgs_sendmail_test_giji_btn").addEventListener("click", () => {
  if(document.getElementById("register-form-error") != null){
    document.getElementById("register-form-error").setAttribute("style","display:none;");
  };
  document.querySelectorAll(".rgssmt_form_field_error")[0].setAttribute("data-rgssmt_sdm_fail","false");
  document.querySelectorAll("#rgs_sendmail_test_main .rgs_sendmail_load_main")[0].setAttribute("data-rgssmt_load_disp","true");
  rgs_load(0);
});

function gtrntl_rgs() {
  const base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let resl = '';
  for (let i = 0; i < 20; i++) {
    const randomIndex = Math.floor(Math.random() * base.length);
    resl += base[randomIndex];
  }
  return resl;
}

function rgs_load(mn) {
  var mn_add = mn + 1;
  if (mn_add < 110) {
    var srclm = document.getElementById("app-embed").shadowRoot.getElementById("custom#lndst_test_st");
    if(srclm != null){
      document.getElementById("rgs_sendmail_test_form").setAttribute("data-rslfrm_srch","true");
      var rgs_test_mail = document.querySelectorAll("#rgs_sendmail_test_main input.rgssmt_bff_inp")[0].value;
      var rgs_test_text = gtrntl_rgs();
      var rgs_test_name = "仮登録_社員販売";
      const clset = new Event('input', { bubbles: true });
      document.getElementById("app-embed").shadowRoot.getElementById("email").setAttribute("aria-invalid","false");
      document.getElementById("app-embed").shadowRoot.getElementById("email").value = rgs_test_mail;
      document.getElementById("app-embed").shadowRoot.getElementById("email").dispatchEvent(clset);
      document.getElementById("app-embed").shadowRoot.getElementById("custom#lndst_test_st").setAttribute("aria-invalid","false");
      document.getElementById("app-embed").shadowRoot.getElementById("custom#lndst_test_st").value = rgs_test_text;
      document.getElementById("app-embed").shadowRoot.getElementById("custom#lndst_test_st").dispatchEvent(clset);
      document.getElementById("app-embed").shadowRoot.querySelectorAll("#form-container-ref button[type='submit']")[0].click();
      conf_sccs(0);
      return;
    }else{
      setTimeout(function () {rgs_load(mn_add);},300);
    };
  }else{
    document.getElementById("rgs_sendmail_test_form").setAttribute("data-rslfrm_srch","false");
    document.querySelectorAll("#rgs_sendmail_test_main .rgs_sendmail_load_main")[0].setAttribute("data-rgssmt_load_disp","false");
    document.querySelectorAll(".rgssmt_form_field_error")[0].setAttribute("data-rgssmt_sdm_fail","true");
    console.log("timeout");
  };
};

function conf_sccs(inv){
  var inv_add = inv + 1;
  if (inv_add < 210) {
    var scs_cnt = document.getElementById("app-embed").shadowRoot.querySelector("#app-embed section[data-testid='banner-success']");
    var cnf_alrt = document.getElementById("app-embed").shadowRoot.querySelector("output[role='alert']");
    if(scs_cnt != null){
      document.querySelectorAll("#rgs_sendmail_test_main .rgs_sendmail_load_main")[0].setAttribute("data-rgssmt_load_disp","false");
      document.querySelectorAll(".rgssmt_form_field_error")[0].setAttribute("data-rgssmt_sdm_fail","false");
      document.getElementById("rgs_sendmail_test_button").click();
    }else if(cnf_alrt != null){
      document.querySelectorAll("#rgs_sendmail_test_main .rgs_sendmail_load_main")[0].setAttribute("data-rgssmt_load_disp","false");
      document.querySelectorAll(".rgssmt_form_field_error")[0].setAttribute("data-rgssmt_sdm_fail","false");
      document.getElementById("rgs_sendmail_test_button").click();
    }else{
      setTimeout(function () {conf_sccs(inv_add);},300);
    };
  }else{
    document.getElementById("rgs_sendmail_test_form").setAttribute("data-rslfrm_srch","false");
    document.querySelectorAll("#rgs_sendmail_test_main .rgs_sendmail_load_main")[0].setAttribute("data-rgssmt_load_disp","false");
    document.querySelectorAll(".rgssmt_form_field_error")[0].setAttribute("data-rgssmt_sdm_fail","true");
  };
};